import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import paths from "@icarius-router/paths";
import { LanguagesIcon, SpecializationsIcon, StudiesIcon, SchoolingIcon } from "@icarius-icons/";
import { getLocalizedString } from "@icarius-localization/strings";

const TrainingData = () => {

  const data = [
    {
      name: getLocalizedString("schooling"),
      icon: <SchoolingIcon />,
      path: paths.schooling,
    },
    {
      name: getLocalizedString("studies"),
      icon: <StudiesIcon />,
      path: paths.studies,
    },
    {
      name: getLocalizedString("specializations"),
      icon: <SpecializationsIcon />,
      path: paths.specializations,
    },
    {
      name: getLocalizedString("languages"),
      icon: <LanguagesIcon />,
      path: paths.languages,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("trainingData")}
      data={data}
    />
  );
}

export default TrainingData;
